module.exports = __webpack_public_path__ + "static/media/Grand_Seminar.754a7171.jpg";